export default {
  // 搜索區
  drawTime: '開獎時間',
  startTime: '開始時間',
  endTime: '結束時間',
  userInfo: '用戶資訊',
  userInfoPlaceholder: '請輸入用戶名稱、UID',
  qrcode: '二維碼',
  qrcodePlaceholder: '請輸入二維碼',
  winStatus: '中獎狀態',
  winStatusPlaceholder: '全部',
  winStatusAll: '全部',
  winStatusWon: '中獎',
  winStatusNotWon: '未中獎',
  activityInfo: '活動資訊',
  activityInfoPlaceholder: '請輸入活動名稱、ID',
  scanRegion: '掃碼國家/地區',
  scanRegionPlaceholder: '全部',
  search: '搜索',
  // 表格列
  colUserInfo: '用戶資訊',
  colQrcode: '二維碼',
  colActivityInfo: '活動資訊',
  colWinStatus: '中獎狀態',
  colPrize: '獎項',
  colDrawTime: '開獎時間',
  colDrawRegion: '開獎地區',
  colAction: '操作',
  // 操作
  detail: '詳情',
  // 詳情彈窗
  detailTitle: '開獎詳情',
  sectionMemberInfo: '開獎人資訊',
  sectionActivityInfo: '開獎活動資訊',
  sectionScanInfo: '掃碼資訊',
  detailMemberId: '用戶ID',
  detailMemberName: '用戶名稱',
  detailPhone: '手機號',
  detailActivityId: '活動ID',
  detailActivityName: '活動名稱',
  detailWinPrize: '中獎獎項',
  detailWinStrategy: '中獎策略',
  detailPrizeContent: '獎項內容',
  prizeGift: '禮品',
  prizePoint: '積分',
  detailCode: '二維碼',
  detailCodeBatch: '二維碼批次',
  detailProduct: '關聯產品',
  detailScanTime: '掃碼時間',
  detailScanRegion: '掃碼國家/地區',
  // 佔位
  dash: '——',
  // 空狀態
  emptyText: '暫無開獎記錄',
};
